import {BaseActionClassModel} from "../base-action-class.model";
import {ActionEnum} from "../action.enum";
import {CompoTreeType} from "../../enums/CompoTreeType";
import {ParentSelectedChildModel} from "../../models/global/parentSelectedChild.model";
import {OrganizationOrLocationNodeModel} from "../../models/organization-location/organization-or-location-node.model";

export namespace OrganizationLocationTreeActions {

  //region yIndex
  export class SetYIndexFor extends BaseActionClassModel {
    static readonly type: ActionEnum = ActionEnum.ORGANIZATION_LOCATION_TREE_SET_Y_INDEX_FOR;

    constructor(public id: string, public type: CompoTreeType, public parentId: string, public index: number) {
      super(null);
    }
  }

  export class RemoveYIndexFor extends BaseActionClassModel {
    static readonly type: ActionEnum = ActionEnum.ORGANIZATION_LOCATION_TREE_REMOVE_Y_INDEX_FOR;

    constructor(public id: string, public type: CompoTreeType) {
      super(null);
    }
  }
  //endregion yIndex

  //region parentSelectedChild
  export class OnParentSelected extends BaseActionClassModel {
    static readonly type: ActionEnum = ActionEnum.ORGANIZATION_LOCATION_TREE_ON_PARENT_SELECTED;

    constructor(public parentChildPair: ParentSelectedChildModel<OrganizationOrLocationNodeModel>) {
      super(null);
    }
  }
  //endregion parentSelectedChild

  //region selection
  export class SetSelection extends BaseActionClassModel {
    static readonly type: ActionEnum = ActionEnum.ORGANIZATION_LOCATION_TREE_SET_SELECTION;

    constructor(public organizationIds: Set<string>, public locationIds: Set<string>) {
      super(null);
    }
  }

  export class SetAllOrganizationIds extends BaseActionClassModel {
    static readonly type: ActionEnum = ActionEnum.ORGANIZATION_LOCATION_TREE_SET_ALL_ORGANIZATION_IDS;

    constructor(public organizationIds: Set<string>) {
      super(null);
    }
  }

  export class SetAllLocationIds extends BaseActionClassModel {
    static readonly type: ActionEnum = ActionEnum.ORGANIZATION_LOCATION_TREE_SET_ALL_LOCATION_IDS;

    constructor(public locationIds: Set<string>) {
      super(null);
    }
  }
  //endregion selection
}
